import { render } from "./ManageAvatarCustomImage.vue?vue&type=template&id=00df4452"
import script from "./ManageAvatarCustomImage.vue?vue&type=script&lang=js"
export * from "./ManageAvatarCustomImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__